import { render, staticRenderFns } from "./NewDownload.vue?vue&type=template&id=6044c60b&scoped=true&"
import script from "./NewDownload.vue?vue&type=script&lang=js&"
export * from "./NewDownload.vue?vue&type=script&lang=js&"
import style0 from "./NewDownload.vue?vue&type=style&index=0&id=6044c60b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6044c60b",
  null
  
)

export default component.exports